package oldcomponents

import bootstrap.Dropdown
import bootstrap.DropdownItem
import bootstrap.DropdownMenu
import bootstrap.DropdownToggle
import js.core.jso
import kotlinx.css.*
import kotlinx.css.properties.Transitions
import kotlinx.css.properties.transform
import kotlinx.css.properties.translateY
import kotlinx.html.*
import kotlinx.html.js.onChangeFunction
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLInputElement
import react.*
import react.dom.*
import react.virtual.useVirtual
import styled.css
import styled.styledDiv
import styled.toStyle



external interface DropdownSelectProps : Props {
    var disabled: Boolean

    var dropdownOpenDefault: Boolean
    var multiSelect: Boolean

    var showFilter: Boolean

    var currentValue: Map<String, String>
    var selectValues: List<Pair<String, String>>

    var onSave: (Map<String, String>) -> Unit

    var width: Int
    var isInvalid: Boolean
}
val dropdownSelect = fc<DropdownSelectProps> { props ->
    var dropdownOpen by useState(if (props.dropdownOpenDefault == undefined) true else props.dropdownOpenDefault)
    var filter by useState("")
    var filtered by useState(props.selectValues)
//    var offset by useState<Int>()

    useEffect(props.selectValues, filter) {
        filtered = props
            .selectValues
            .filter { filter.isBlank() || it.first == filter || it.second.lowercase().contains(filter.lowercase()) }
            .sortedWith { a, b ->
                val selectCompare = props.currentValue.containsKey(a.first).compareTo(props.currentValue.containsKey(b.first)) * 1000
                a.first.compareTo(b.first) - selectCompare
            }
    }

    var menu by useState<ComponentType<PropsWithRef<DIV>>>()
    useEffect(filtered, props.currentValue, props.width) {
        val dropdownWidth = if (props.width == undefined) 300 else props.width
//        var scroll = offset
//        CoroutineScope(Dispatchers.Unconfined).launch {
//            delay(300)
//            scroll = null
//        }
        menu = forwardRef<DIV, PropsWithRef<DIV>> { p, rRef ->
            styledDiv {
                css {
                    p.unsafeCast<PropsWithClassName>().className?.let {
                        classes.add(it.toString())
                    }
                    zIndex = 100
                }
                ref = rRef
                if (props.showFilter) {
                    div("ml-2 mr-2 mb-2") {
                        input(InputType.text, classes = "form-control") {
                            attrs.autoFocus = true
                            attrs.placeholder = "Фильтр..."
                            attrs.value = filter
                            attrs.onChangeFunction = {
                                filter = (it.target as? HTMLInputElement)?.value.orEmpty()
                            }
                        }
                    }
                }


                if (props.multiSelect) {
                    div("bs-actionsbox") {
                        div("btn-group btn-group-sm btn-block") {
                            attrs.role = "group"
                            button(type = ButtonType.button, classes = "actions-btn bs-select-all btn btn-light mb-2 mt-2 ml-2") {
                                attrs.onClickFunction = {
                                    props.onSave(
                                        filtered.toMap()
                                    )
                                }
                                +"Выбрать все"
                            }
                            button(type = ButtonType.button, classes = "actions-btn bs-select-all btn btn-light mb-2 mt-2 mr-2") {
                                attrs.onClickFunction = {
                                    props.onSave(mapOf())
                                }
                                +"Убрать все"
                            }
                        }
                    }
                }

                val ref = useRef<DIV>()
                val virtualList = useVirtual<DIV>(jso {
                    this.size = filtered.size
                    this.parentRef = ref
                    this.estimateSize = useCallback { _: Int -> 28 }
                    this.estimateSize
//                    this.scrollOffsetFn = {
//                        val top = (it?.target as? HTMLDivElement)?.scrollTop?.toInt() ?: 0
//                        offset = top
//                        top
//                    }
                })
//                scroll?.let {
//                    if (it >= 0) {
//                        virtualList.scrollToOffset(it, jso {})
//                    }
//                }

                styledDiv {
                    this.ref = ref
                    css {
                        classes.add("basic-scroll")
                        maxHeight = 300.px
                        minWidth = dropdownWidth.px
                        overflow = Overflow.auto
                        outline = Outline.none
                    }

                    styledDiv {
                        css {
                            height = virtualList.totalSize.px
                            width = 100.pct
                            minWidth = dropdownWidth.px
                            position = kotlinx.css.Position.relative
                        }

                        virtualList.virtualItems.forEach {
                            val (id, name) = filtered[it.index]

                            DropdownItem {
                                attrs.active = props.currentValue.keys.contains(id)
                                attrs.eventKey = id

                                attrs.style = StyledElement().apply {
                                    position = kotlinx.css.Position.absolute
                                    top = 0.px
                                    left = 0.px
                                    width = 100.pct
                                    minWidth = 300.px
                                    height = it.size.px
                                    transform {
                                        translateY(it.start.px)
                                    }
                                    transition = Transitions.none
                                }.toStyle(true)

                                +name
                            }
                        }
                    }
                }

                if (props.showFilter) {
                    div("mt-2 ml-2 mr-2") {
                        p("text-right") {
                            +"Показано ${filtered.size} из ${props.selectValues.size}"
                        }
                    }
                }
            }
        }
    }

    Dropdown {
        attrs.onToggle = { isOpen, _, metadata ->
            if (isOpen || (undefined != metadata && undefined != metadata.source && metadata.source != "select") || !props.multiSelect) {
                dropdownOpen = isOpen
            }
        }
        attrs.show = dropdownOpen
        attrs.onSelect = { key, _ ->
            val id = key as String
            val name = props.selectValues.firstOrNull { it.first == id }?.second.orEmpty()
            props.onSave(
                when {
                    !props.multiSelect -> mapOf(id to name)
                    props.currentValue.contains(id) -> props.currentValue.minus(id)
                    else -> props.currentValue.plus(id to name)
                }
            )
            if (!props.multiSelect)
                dropdownOpen = false
        }
        DropdownToggle {
            attrs.`as` = forwardRef<INPUT, PropsWithRef<INPUT>> { p, rRef ->
                input(InputType.text) {
                    val classes = attrs.classes.toMutableSet()
                    classes += "form-control"
                    if (props.isInvalid) {
                        classes += "is-invalid"
                    }
                    attrs.classes = classes

                    ref = rRef
                    attrs.contentEditable = false
                    attrs.defaultValue = if (props.selectValues == undefined || props.selectValues.isEmpty()) "Отсутствуют элементы для выбора" else props.currentValue.map { it.value }.joinToString("; ")
                    attrs.onClickFunction = {
                        dropdownOpen = !dropdownOpen
                    }
                    attrs.disabled = if (props.disabled != undefined) props.disabled else false
                }
            }
        }
        DropdownMenu {
            attrs.show = dropdownOpen
            menu?.let {
                attrs.`as` = it
            }
        }
    }
}